import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

export default function TreatmentContent({
  title,
  heroImage,
  intro,
  description,
  whatIs,
  whatIsImage,
  howItWorks,
  benefits = [],
  beforeAfterImages = [],
  faqs = [],
}) {
  const fadeUp = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <div>
      {/* 1. Hero Image */}
      {heroImage && (
        <motion.div {...fadeUp} className="mb-4">
          <img
            src={heroImage}
            alt={title}
            className="img-fluid rounded shadow w-100 mb-3"
          />
          {intro && <p className="fs-5">{intro}</p>}
        </motion.div>
      )}

      {/* 2. Title / About */}
      <motion.div {...fadeUp} className="mb-4">
        <h2 className="fw-bold mb-3">{title}</h2>
        {description && <p className="text-muted mb-4">{description}</p>}
      </motion.div>

      {/* 3. What is + Image */}
      {whatIs && (
        <motion.div {...fadeUp} className="mb-5">
          {whatIsImage && (
            <img
              src={whatIsImage}
              alt={`What is ${title}`}
              className="img-fluid rounded shadow w-100 mb-3"
            />
          )}
          <h3 className="fw-bold mb-2">What is this Treatment?</h3>
          <p>{whatIs}</p>
        </motion.div>
      )}

      {/* 4. How it Works */}
      {howItWorks && (
        <motion.div {...fadeUp} className="mb-5">
          <h3 className="fw-bold mb-2">How It Works</h3>
          <p>{howItWorks}</p>
        </motion.div>
      )}

      {/* 5. Benefits */}
      {benefits.length > 0 && (
        <motion.div {...fadeUp} className="mb-5">
          <h3 className="fw-bold mb-2">Benefits</h3>
          <ul className="ps-3">
            {benefits.map((b, idx) => (
              <li key={idx} className="mb-1">{b}</li>
            ))}
          </ul>
        </motion.div>
      )}

      {/* 6. Before & After */}
      {beforeAfterImages.length > 0 && (
        <motion.div {...fadeUp} className="mb-5">
          <h3 className="fw-bold mb-3">Before & After</h3>
          <Row className="justify-content-between g-3">
            {beforeAfterImages.map((img, idx) => (
              <Col
                key={idx}
                xs={12} sm={6} md={6} lg={5}
                className="d-flex justify-content-center"
              >
                <Card className="shadow-sm w-100">
                  <Card.Img src={img} alt={`Before After ${idx}`} className="w-100 rounded" />
                  <Card.Body className="text-center fw-bold">
                    {idx === 0 ? "Before" : "After"}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </motion.div>
      )}
    </div>
  );
}
